import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLocalStorageState } from '@/hooks/ai-agents/useLocalStorageState';

interface HomeButtonProps {
  className?: string;
  size?: number;
  label?: string;
}

const HomeButton: React.FC<HomeButtonProps> = ({ 
  className,
  size = 18,
  label = "Home"
}) => {
  const navigate = useNavigate();
  const { isModalOpen, closeModal } = useLocalStorageState();
  
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // Close chat modal if it's open (same pattern as other navbar buttons)
    if (isModalOpen) {
      closeModal();
    }
    navigate('/home');
  };

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className={cn(
        "relative h-12 w-12 rounded-md overflow-hidden inline-flex items-center justify-center",
        "ring-2 ring-white/20 dark:ring-slate-800/40",
        "shadow-md hover:shadow-lg",
        "transition-all duration-200",
        "cursor-pointer",
        className
      )}
      aria-label={label}
      onClick={handleClick}
    >
      {/* Apply gradient directly to a full-size inner div */}
      <div className={cn(
        "absolute inset-0 bg-gradient-to-br from-brandPurple to-brandBlue dark:from-[#622bfe] dark:to-[#283dae]",
        "transition-colors duration-200"
      )} />
      
      {/* Icon container */}
      <div className={cn(
        "relative z-10 flex items-center justify-center",
        "text-white"
      )}>
        <Home size={size} />
      </div>
    </motion.div>
  );
};

export default HomeButton;
